export default {"src":"/_next/static/media/rightarrow.0aa0a348.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};